// Central config — use BACKEND_URL instead of process.env.REACT_APP_BACKEND_URL directly
// so every build works even when the env var is not set (relative URLs via nginx proxy).
// Event microsite hosts always use their own origin (see lib/microsite.js).
import { isPortalHost } from './microsite';

export const BACKEND_URL = isPortalHost() ? (process.env.REACT_APP_BACKEND_URL || '') : '';
